
import { getSlug, preloadSecondaryImage, renderProductTile, setupImageSwapObserver, getFocusableElements, trapFocus, enableFocusTrap, disableFocusTrap } from './custom-utils.js';
import { isMobileBreakpoint } from './utilities.js';

const isMobile = isMobileBreakpoint();

document.addEventListener('DOMContentLoaded', () => {
    // Utility: Get scroll buttons
    function getScrollButtons() {
        return {
            left: document.querySelector('.quicklinks-scroll-left'),
            right: document.querySelector('.quicklinks-scroll-right'),
        };
    }

    // Utility: Set scroll button visibility
    function setScrollButtonsVisibility(visible) {
        const { left, right } = getScrollButtons();
        // Use global d-none class for hiding, remove for showing
        [left, right].forEach(btn => {
            if (!btn) return;
            if (visible) {
                btn.classList.remove('d-none');
            } else {
                btn.classList.add('d-none');
            }
        });
    }

    // Utility: Toggle visibility for d-none/d-inline-flex
    function toggleVisibility(elem, visible) {
        if (!elem) return;
        elem.classList.toggle('d-none', !visible);
        elem.classList.toggle('d-inline-flex', visible);
    }
    
    // Check for the library immediately
    const { autocomplete, getAlgoliaResults } = window['@algolia/autocomplete-js'];
    
    if (!autocomplete) {
        return; // Stop execution if the library isn't there
    }

    // 1. Initialize the Algolia Search Client
    const searchClient = algoliasearch(
        window.algolia_application_id,              // **REQUIRED:** Your Application ID
        window.algolia_search_key  // **REQUIRED:** Your Search-Only API Key (NEVER use the Admin Key)
    );

    // 2. Initialize the Autocomplete Component

    // Place the autocomplete container after the close button
    const closeBtn = document.getElementById('algolia-modal-close');
    const input = document.getElementById('autocomplete-0-input');
    const dialog = document.querySelector('.search-modal__content.dialog-modal');
    const results = document.getElementById('algolia-modal-results');
    const heading = document.getElementById('algolia-modal-heading');
    heading?.classList.add('hide')
    document.getElementById('algolia-modal-viewall-top')?.classList.add('hide');
    const viewAllTop = document.getElementById('algolia-viewall-top');
    viewAllTop?.classList.add('link')
    const viewAllBottom = document.getElementById('algolia-viewall-bottom');

    

    // --- Close Modal Functionality --
    function resetSearchModalState() {
        // Clear input value using Algolia Autocomplete setter
        if (instance && typeof instance.setQuery === 'function') {
            instance.setQuery('');
            if (typeof instance.refresh === 'function') instance.refresh();
        } else if (input && 'value' in input) {
            input.value = '';
        }
        // Hide view all buttons
        if (viewAllTop) {
            toggleVisibility(viewAllTop, false);
        }
        if (viewAllBottom) {
            toggleVisibility(viewAllBottom, false);
        }
        // Reset heading
        if (heading) heading.textContent = 'Most Popular Searches';
        if (results) results.innerHTML = '';
        // Disable focus trap on close
        disableFocusTrap(dialog);
    }

    // Close the modal immediately on page load
    if (dialog && typeof dialog.close === 'function') dialog.close();
    document.body.classList.remove('modal-open');
    document.body.style.top = '';

    let blurTimeout;

    async function loadEmptyStateFallback(query) {
        const resultsContainer = document.getElementById('algolia-modal-results');

        if (!resultsContainer) return;

        // Clear product area before injecting fallback
        resultsContainer.innerHTML = "";

        // 1️⃣ Fetch RECENTLY ORDERED PRODUCTS
        const recent = await searchClient
            .initIndex(window.algolia_purchase_index)
            .search("", {
                hitsPerPage: 6,
                filters: "inventory_available:true OR product_type:'Gift Cards'",
            });

        // Render product tiles inside wrapper div
        const recentHTML = recent.hits
            .map(hit => {
                if(!isMobile) {
                    preloadSecondaryImage(hit.handle);
                }
                return renderProductTile(hit);
            })
            .join("");

        resultsContainer.innerHTML = `<div id="algolia-modal-search-results">${recentHTML}</div>`;
        // ⭐ CALL IMAGE SWAP SETUP AFTER PRODUCT RENDERING (Active Search Query) ⭐
        if(!isMobile) {
            setupImageSwapObserver();
        }  
        
        // Debounce blur: only blur if user hasn't typed for 500ms
        const inputEl = document.getElementById('autocomplete-0-input');
        if (inputEl) {
            clearTimeout(blurTimeout);
            blurTimeout = setTimeout(() => {
                // Only blur if input is not focused (user not typing)
                    inputEl.blur();
                
            }, 2000);
        }
    }
    closeBtn.onclick = function () {
        resetSearchModalState();
        if (dialog && typeof dialog.close === 'function') {
            dialog.close();
        }
        document.body.classList.remove('modal-open');
        document.body.style.top = '';
    };

    // Enable focus trap when modal is opened
    if (dialog) {
        const observer = new MutationObserver(() => {
            if (dialog.hasAttribute('open')) {
                enableFocusTrap(dialog);
            } else {
                disableFocusTrap(dialog);
            }
        });
        observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
        // Also enable on load if already open
        if (dialog.hasAttribute('open')) enableFocusTrap(dialog);
    }

    dialog && dialog.addEventListener('click', function(event) {
        if (event.target === dialog) {
            resetSearchModalState();
        }
    });
    // Create a wrapper for autocomplete
    let autocompleteWrapper = document.getElementById('aa-autocomplete-wrapper');
    if (!autocompleteWrapper) {
        autocompleteWrapper = document.createElement('div');
        autocompleteWrapper.id = 'aa-autocomplete-wrapper';
        closeBtn.insertAdjacentElement('afterend', autocompleteWrapper);
    }
    const instance = autocomplete({
        container: '#aa-autocomplete-wrapper',
        placeholder: 'Search products...',
        panelContainer: document.getElementById('algolia-modal-results'),
        openOnFocus: true,
        insights: true,
        autoFocus: true,
        detachedMediaQuery: 'none',
        debug: true,
        onSubmit({ state }) {
            const query = state.query && state.query.trim();
            if (!query) {
                if (event && typeof event.preventDefault === 'function') {
                    event.preventDefault();
                }
                input?.focus();
                if (instance && typeof instance.setQuery === 'function') {
                    instance.setQuery('');
                    if (typeof instance.refresh === 'function') instance.refresh();
                }
                return false;
            }
            if (query) {
                window.location.href = '/search?q=' + encodeURIComponent(query);
                if (instance && typeof instance.setQuery === 'function') {
                    if (typeof instance.refresh === 'function') instance.refresh();
                }
                setTimeout(() => {
                    closeBtn?.click();
                }, 20);
                return false;
            }
        },
        onStateChange({ state }) {
            // Only update quicklinks if the input field is focused
            const inputEl = document.getElementById('autocomplete-0-input');
            if (inputEl && document.activeElement === inputEl) {
                // Build collectionsBySource from state
                const collectionsBySource = {
                    products: [],
                    purchase_empty: [],
                    suggestions: [],
                    empty_suggestions: []
                };
                if (state && state.collections) {
                    state.collections.forEach(col => {
                        if (col.source.sourceId === 'suggestions') {
                            collectionsBySource.suggestions = col.items;
                        }
                        if (col.source.sourceId === 'products') {
                            collectionsBySource.products = col.items;
                        }
                        if (col.source.sourceId === 'purchase_empty') {
                            collectionsBySource.purchase_empty = col.items;
                        }
                        if (col.source.sourceId === 'empty_suggestions') {
                            collectionsBySource.empty_suggestions = col.items;
                        }
                    });
                }

                // Pass a new state object with collectionsBySource
                updateQuicklinksFromState({ collectionsBySource });
            }
        },
        getSources({ query }) {
            let errorMsg = document.getElementById('algolia-modal-error');
            if (!errorMsg) {
                errorMsg = document.createElement('div');
                errorMsg.id = 'algolia-modal-error';
                errorMsg.textContent = '';
                errorMsg.className='hide';
                const headerRow = document.querySelector('.algolia-modal-header-row');
                if (headerRow && headerRow.parentNode) {
                    headerRow.parentNode.insertBefore(errorMsg, headerRow);
                }
            }
            // if (errorMsg) errorMsg.remove();
            // Update heading based on query
            if (heading) {
                if (query && query.trim()) {
                    heading.textContent = 'Suggestions';
                    if (viewAllTop) {
                        toggleVisibility(viewAllTop, true);
                        viewAllTop.href = '/search?q=' + encodeURIComponent(query);
                    }
                    if (viewAllBottom) {
                        toggleVisibility(viewAllBottom, true);
                        viewAllBottom.href = '/search?q=' + encodeURIComponent(query);
                    }
                } else {
                    heading.textContent = '';
                    if (viewAllTop) {
                        toggleVisibility(viewAllTop, false);
                    }
                    if (viewAllBottom) {
                        toggleVisibility(viewAllBottom, false);
                    }
                }
            }
            function getSuggestionsSource(query='') {
                return {
                    sourceId: 'suggestions',
                    async getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: window.algolia_query_suggestions_index,
                                    query,
                                    params: {
                                        hitsPerPage: 15,
                                        attributesToHighlight: [
                                            'query'
                                        ],
                                        attributesToSnippet: ['title:10'],
                                        snippetEllipsisText: '…',
                                    },
                                },
                            ],
                        });
                    },
                    templates: {
                        item() {},
                        noResults() {},
                    },
                };
            }
            function getNoResultsSuggestionsSource() {
                return {
                    sourceId: 'empty_suggestions',
                    async getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: window.algolia_query_suggestions_index,
                                    params: {
                                        hitsPerPage: 15,
                                        attributesToHighlight: [
                                            'query'
                                        ],
                                        attributesToSnippet: ['title:10'],
                                        snippetEllipsisText: '…',
                                    },
                                },
                            ],
                        });
                    },
                    templates: {
                        item() {},
                        noResults() {},
                    },
                };
            }
            if (!query || !query.trim()) {
                // Show purchase products when query is empty
                return [
                    {
                        sourceId: 'purchase',
                        getItemInputValue: () => "",
 
                        async getItems() {
                            return getAlgoliaResults({
                                searchClient,
                                queries: [
                                    {
                                        indexName: window.algolia_purchase_index,
                                        query,
                                        params: {
                                            hitsPerPage: 6,
                                            filters: "inventory_available:true OR product_type:'Gift Cards'",
                                        },
                                    },
                                ],
                            });
                        },
                        templates: {
                            item({ item, html }) {
                                dialog?.classList.remove('no-results-found');
                                if (heading) heading.textContent = 'Most Popular Searches';
                                if (viewAllTop) {
                                    toggleVisibility(viewAllTop, false);
                                }
                                if (viewAllBottom) {
                                    toggleVisibility(viewAllBottom, false);
                                }
                                let errorMsg = document.getElementById('algolia-modal-error');
                                errorMsg?.classList?.add('hide');
                                // Remove fallback wrapper if present before rendering autocomplete results
                                const wrapper = document.getElementById('algolia-modal-search-results');
                                if (wrapper) wrapper.remove();
                                if(!isMobile) {
                                    preloadSecondaryImage(item.handle);
                                }
                                const rendered = html([renderProductTile(item,true)]);
                                // ⭐ ADDED: Explicit DOM Cleanup BEFORE setupImageSwapObserver ⭐
                                // This targets the specific element that was just inserted (rendered)
                                const newHitElement = document.querySelector(`[data-handle="${item.handle}"]`); 
                                if (newHitElement) {
                                    // 1. Remove the hover class immediately if it somehow persisted
                                    newHitElement.removeAttribute('data-hoverInit');
                                    // 2. Clear any lingering content inside the placeholder
                                    const placeholder = newHitElement.querySelector('.secondary-image-placeholder');
                                    if (placeholder) {
                                        placeholder.innerHTML = '';
                                        placeholder.removeAttribute('data-image-loaded');
                                    }
                                }
                                // ⭐ END CLEANUP ⭐
                                //⭐ CALL IMAGE SWAP SETUP AFTER PRODUCT RENDERING (Active Search Query) ⭐
                                setTimeout(() => {
                                    if (typeof setupImageSwapObserver === 'function' && !isMobile) {
                                        setupImageSwapObserver();
                                    }
                                }, 10);
                                return rendered;
                            },
                        },
                    },
                    getSuggestionsSource(query),
                    getNoResultsSuggestionsSource(),
                ];
            }
            // Otherwise, show products from products index only
            return [
                {
                    sourceId: 'products',
                    getItemInputValue: ({ item }) => item.title,
                    async getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: window.algolia_primary_index,
                                    query,
                                    params: {
                                        hitsPerPage: 6,
                                        filters: "inventory_available:true OR product_type:'Gift Cards'",
                                        attributesToSnippet: ['title:10'],
                                        snippetEllipsisText: '…',
                                        attributesToHighlight: [
                                            'handle',
                                            'title',
                                            'vendor',
                                            'options.color',
                                            'tags'
                                            
                                            // '*', // returns all attributes in the index not just searchable attributes
                                        
                                        ],
                                    },
                                },
                            ],
                        });
                    },
                    templates: {
                        item({ item, html }) {
                            dialog?.classList.remove('no-results-found');
                            let errorMsg = document.getElementById('algolia-modal-error');
                            errorMsg?.classList?.add('hide');
                            const wrapper = document.getElementById('algolia-modal-search-results');
                            if (wrapper) wrapper.remove();
                            if(!isMobile) {
                                preloadSecondaryImage(item.handle);
                            }
                            const rendered = html([renderProductTile(item,true)]);
                            // ⭐ ADDED: Explicit DOM Cleanup BEFORE setupImageSwapObserver ⭐
                            // This targets the specific element that was just inserted (rendered)
                            const newHitElement = document.querySelector(`[data-handle="${item.handle}"]`); 
                            if (newHitElement) {
                                // 1. Remove the hover class immediately if it somehow persisted
                                newHitElement.removeAttribute('data-hoverInit');
                                // 2. Clear any lingering content inside the placeholder
                                const placeholder = newHitElement.querySelector('.secondary-image-placeholder');
                                if (placeholder) {
                                    placeholder.innerHTML = '';
                                    placeholder.removeAttribute('data-image-loaded');
                                }
                            }
                            // // ⭐ END CLEANUP ⭐
                            // ⭐ CALL IMAGE SWAP SETUP AFTER PRODUCT RENDERING (Active Search Query) ⭐
                            setTimeout(() => {
                                if (typeof setupImageSwapObserver === 'function' && !isMobile) {
                                    setupImageSwapObserver();
                                }
                            }, 10);
                            return rendered;
                        }
                    },
                },
                {
                    sourceId: 'purchase_empty',
                    getItemInputValue: ({ item }) => item.title,
                    async getItems() {
                        return getAlgoliaResults({
                            searchClient,
                            queries: [
                                {
                                    indexName: window.algolia_purchase_index,
                                    query: '',
                                    params: {
                                        hitsPerPage: 6,
                                        filters: "inventory_available:true OR product_type:'Gift Cards'",
                                        attributesToSnippet: ['title:10'],
                                        snippetEllipsisText: '…',
                                        attributesToHighlight: [
                                            'handle',
                                            'title',
                                            'vendor',
                                            'options.color',
                                            'tags'
                                            
                                            // '*', // returns all attributes in the index not just searchable attributes
                                        
                                        ],
                                    },
                                },
                            ],
                        });
                    },
                    templates: {
                        item({ item, html }) {
                            const wrapper = document.getElementById('algolia-modal-search-results');
                            if (wrapper) wrapper.remove();
                            if(!isMobile) {
                                preloadSecondaryImage(item.handle);
                            }
                            const rendered = html([renderProductTile(item,true)]);
                            // ⭐ ADDED: Explicit DOM Cleanup BEFORE setupImageSwapObserver ⭐
                            // This targets the specific element that was just inserted (rendered)
                            const newHitElement = document.querySelector(`[data-handle="${item.handle}"]`); 
                            if (newHitElement) {
                                // 1. Remove the hover class immediately if it somehow persisted
                                newHitElement.removeAttribute('data-hoverInit');
                                // 2. Clear any lingering content inside the placeholder
                                const placeholder = newHitElement.querySelector('.secondary-image-placeholder');
                                if (placeholder) {
                                    placeholder.innerHTML = '';
                                    placeholder.removeAttribute('data-image-loaded');
                                }
                            }
                            // // ⭐ END CLEANUP ⭐
                            // ⭐ CALL IMAGE SWAP SETUP AFTER PRODUCT RENDERING (Active Search Query) ⭐
                            setTimeout(() => {
                                if (typeof setupImageSwapObserver === 'function' && !isMobile) {
                                    setupImageSwapObserver();
                                }
                            }, 10);
                            return rendered;
                        }
                    },
                },
                getSuggestionsSource(query),
                getNoResultsSuggestionsSource(),
            ];
        }
    });
    if(isMobile) {
        // ---- iPhone FIX: trusted tap navigation via delegated listener with scroll suppression ----
        (function attachTrustedNavigation() {
            const root = document.querySelector('#algolia-modal-results');
            if (!root) return;

            let startY = 0, startX = 0, moved = false;
            const SCROLL_THRESHOLD = 10; // px

            function navigateTrusted(url) {
                if (!url) return;
                const a = document.createElement('a');
                a.href = url;
                a.rel = 'noopener noreferrer';
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click(); // real trusted click
                setTimeout(() => {
                    closeBtn?.click();
                }, 20);
                setTimeout(() => a.remove(), 50);
            }

            function onTouchStart(e) {
                moved = false;
                if (e.touches && e.touches.length) {
                    startY = e.touches[0].clientY;
                    startX = e.touches[0].clientX;
                } else {
                    startY = e.clientY;
                    startX = e.clientX;
                }
            }

            function onTouchMove(e) {
                let y = e.touches && e.touches.length ? e.touches[0].clientY : e.clientY;
                let x = e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
                if (Math.abs(y - startY) > SCROLL_THRESHOLD || Math.abs(x - startX) > SCROLL_THRESHOLD) {
                    moved = true;
                }
            }

            function handler(e) {
                // Suppress navigation if scroll detected
                if (moved) return;
                const el = e.target.closest('[data-handle], [data-url]');
                if (!el) return;

                const url = el.dataset.url || `/products/${el.dataset.handle}`;
                if (!url) return;

                // Prevent double triggers
                if (el.__navigated) return;
                el.__navigated = true;

                e.stopPropagation(); // prevent Algolia synthetic handling
                e.preventDefault();
                navigateTrusted(url);
                setTimeout(() => { el.__navigated = false }, 600);
            }

            // MUST use capture so it fires BEFORE Algolia's listeners
            root.addEventListener('touchstart', onTouchStart, { capture: true, passive: false });
            root.addEventListener('touchmove', onTouchMove, { capture: true, passive: false });
            root.addEventListener('touchend', handler, { capture: true, passive: false });
            root.addEventListener('mousedown', handler, { capture: true });
        })();
    }

    // Block autocomplete's handler when clicking outside the panel
    document.addEventListener(
        "mousedown",
        (e) => {
        const panel = document.querySelector(".aa-Panel");
        if (!panel) return;
        if (!panel.contains(e.target)) {
            e.stopImmediatePropagation();
        }
        },
        true // capture mode so Algolia never sees the event
    );

    document.addEventListener(
        "touchstart",
        (e) => {
        const panel = document.querySelector(".aa-Panel");
        if (!panel) return;
        if (!panel.contains(e.target)) {
            e.stopImmediatePropagation();
        }
        },
        true // capture mode so Algolia never sees the event
    );

    // Enable quicklinks scroll left/right functionality
    const quicklinks = document.getElementById('algolia-modal-quicklinks');
    const scrollLeftBtn = document.querySelector('.quicklinks-scroll-left');
    const scrollRightBtn = document.querySelector('.quicklinks-scroll-right');

    if (scrollLeftBtn && quicklinks) {
        scrollLeftBtn.addEventListener('click', () => {
            quicklinks.scrollBy({ left: -200, behavior: 'smooth' });
        });
    }
    if (scrollRightBtn && quicklinks) {
        scrollRightBtn.addEventListener('click', () => {
            quicklinks.scrollBy({ left: 200, behavior: 'smooth' });
        });
    }

    function buildLink(type='',category='',subcategory='') {
        let link;
        if(subcategory) {
            link = getSlug(category) + `?refinementList[named_tags.categories.lvl2][0]=${encodeURIComponent(subcategory)}`
        } else if(category) {
            link = getSlug(category)
        } else {
            link = getSlug(type)
        }
        return link;
    }
    function updateQuicklinksFromState(state){
        const quicklinksContainer = document.getElementById('algolia-modal-quicklinks');
        if (!quicklinksContainer) return;

        // Get the current query from the input field
        const inputEl = document.getElementById('autocomplete-0-input');
        const queryVal = inputEl && 'value' in inputEl ? String(inputEl.value).trim() : '';
        let suggestions = state.collectionsBySource.suggestions || [];
        const empty_suggestions = state.collectionsBySource.empty_suggestions || [];
        const products = state.collectionsBySource.products || [];
        const purchase_empty = state.collectionsBySource.purchase_empty || [];
    
        if(purchase_empty.length > 0 && queryVal !== '' && products.length === 0) {
            dialog?.classList.add('no-results-found');
            let errorMsg = document.getElementById('algolia-modal-error');
            if (!errorMsg) {
                errorMsg = document.createElement('div');
                errorMsg.id = 'algolia-modal-error';
                const headerRow = document.querySelector('.algolia-modal-header-row');
                if (headerRow && headerRow.parentNode) {
                    headerRow.parentNode.insertBefore(errorMsg, headerRow);
                }
            }
            errorMsg.textContent = `Sorry, there are no results for '${queryVal}'`;
            errorMsg?.classList?.remove('hide');
            // Set heading to 'Most Popular Searches'
            if (heading) heading.textContent = 'Most Popular Searches';

            // Hide View All buttons
            if (viewAllTop) {
                toggleVisibility(viewAllTop, false);
            }
            if (viewAllBottom) {
                toggleVisibility(viewAllBottom, false);
            }
        } else {
            dialog?.classList.remove('no-results-found');
            let errorMsg = document.getElementById('algolia-modal-error');
            errorMsg?.classList?.add('hide');
            // Set heading to 'Most Popular Searches'
            if (heading) heading.textContent = queryVal ? 'Suggestions' : 'Most Popular Searches';

            // Hide View All buttons
            if(queryVal) {
                if (viewAllTop) {
                    toggleVisibility(viewAllTop, true);
                    viewAllTop.href = '/search?q=' + encodeURIComponent(queryVal);
                }
                if (viewAllBottom) {
                    toggleVisibility(viewAllBottom, true);
                    viewAllBottom.href = '/search?q=' + encodeURIComponent(queryVal);
                }
            } else {
                if (viewAllTop) {
                    toggleVisibility(viewAllTop, false);
                }
                if (viewAllBottom) {
                    toggleVisibility(viewAllBottom, false);
                }
            }
            
        }
        
        // Special quicklink for queries containing both 'gift' and 'card' (even partial)
        // Or for queries containing 'olivela' (case-insensitive)
        let collectionArr = [];
        let suggestionArr = [];
        let results = [];

        // Pills rendering logic based on queryVal and products
        if (!queryVal || (queryVal && products.length === 0)) {
            if(suggestions.length === 0) {
                suggestions = empty_suggestions;
            }
            // No query: show suggestions with query matchLevel 'full' or 'none'
            suggestions.forEach(hit => {
                if (hit && hit._highlightResult && hit._highlightResult.query && (hit._highlightResult.query.matchLevel === 'full' || hit._highlightResult.query.matchLevel === 'none')) {
                    const text = String(hit.query).toLowerCase();
                    if (text.includes('gift') || text.includes('card') || text.includes('olivela')) {
                        suggestionArr.push({
                            'type': 'gift-card',
                            'label': 'Olivela'
                        }); 
                        suggestionArr.push({
                            'type': 'gift-card',
                            'label': 'Gift Cards'
                        });
                    } else {
                        suggestionArr.push({
                            'type': 'search',
                            'label': hit.query
                        });
                    }
                }
            });
            results = suggestionArr;
        } else if (queryVal && products.length > 0) {
            // Query present and products found
            // 1. Suggestions with query matchLevel 'full'
            suggestions.forEach(hit => {
                if (hit && hit._highlightResult && hit._highlightResult.query && hit._highlightResult.query.matchLevel === 'full') {

                    const text = String(hit.query).toLowerCase();
                    if (text.includes('gift') || text.includes('card') || text.includes('olivela')) {
                        suggestionArr.push({
                            'type': 'gift-card',
                            'label': 'Olivela'
                        });
                        suggestionArr.push({
                            'type': 'gift-card',
                            'label': 'Gift Cards'
                        });
                    } 
                }
            });
            // 2. Products with vendor matchLevel 'full'
            products.forEach(hit => {
                if (hit && hit.vendor) {
                    if(hit.vendor.toLowerCase() === 'olivela') {
                        suggestionArr.push({
                            'type': 'gift-card',
                            'label': 'Olivela'
                        });
                    } else {
                        suggestionArr.push({
                            'type': 'collection',
                            'label': hit.vendor,
                            'link' : buildLink(hit.vendor)
                        });
                    }
                }
                // 3. Products with named_tags
                if (hit && hit.named_tags) {
                    // Support both array and object (JSON) structures
                    if (typeof hit.named_tags === 'object' && hit.named_tags !== null) {
                        // JSON object with keys as categories.lvl0 and categories.lvl1
                        if (hit.named_tags['categories.lvl0']) {
                            const lvl0 = hit.named_tags['categories.lvl0'];
                            if (Array.isArray(lvl0)) {
                                lvl0.forEach(val => {
                                    if (val) {
                                        collectionArr.push({
                                            'type': 'collection',
                                            'link': buildLink(val),
                                            'label': val
                                        });
                                    }
                                });
                            } else if (typeof lvl0 === 'string') {
                                collectionArr.push({
                                    'type': 'collection',
                                    'link': buildLink(lvl0),
                                    'label': lvl0
                                });
                            }
                        }
                        if (hit.named_tags['categories.lvl1']) {
                            const lvl1 = hit.named_tags['categories.lvl1'];
                            if (Array.isArray(lvl1)) {
                                lvl1.forEach(val => {
                                    if (val) {
                                        const parts = val.split('>');
                                        const last = parts[parts.length - 1].trim();
                                        collectionArr.push({
                                            'type': 'collection',
                                            'link': buildLink('',last),
                                            'label': last
                                        });
                                    }
                                });
                            } else if (typeof lvl1 === 'string') {
                                const parts = lvl1.split('>');
                                const last = parts[parts.length - 1].trim();
                                collectionArr.push({
                                    'type': 'collection',
                                    'label': last,
                                    'link': buildLink('',last)
                                });
                            }
                        }
                        if (hit.named_tags['categories.lvl2']) {
                            const lvl2 = hit.named_tags['categories.lvl2'];
                            if (Array.isArray(lvl2)) {
                                lvl2.forEach(val => {
                                    if (val) {
                                        const parts = val.split('>');
                                        const last = parts[parts.length - 1].trim();
                                        collectionArr.push({
                                            'type': 'collection',
                                            'link': buildLink('',parts[parts.length - 2].trim(),val),
                                            'label': last
                                        });
                                    }
                                });
                            } else if (typeof lvl2 === 'string') {
                                const parts = lvl2.split('>');
                                const last = parts[parts.length - 1].trim();
                                collectionArr.push({
                                    'type': 'collection',
                                    'label': last,
                                    'link': buildLink('',parts[parts.length - 2].trim(),lvl2)
                                });
                            }
                        }
                    }
                }
            });

            results = suggestionArr.concat(collectionArr);
        }


         // Remove duplicate values from results (by label and type)
         const uniqueResults = [];
         const seen = new Set();
         (results || []).forEach(item => {
             if (!item || !item.label) return;
             const key = item.type + '|' + item.label.toLowerCase();
             if (!seen.has(key)) {
                 uniqueResults.push(item);
                 seen.add(key);
             }
         });

         // Render pills from uniqueResults array
         const pillHtmlArr = uniqueResults.map(item => {
             if (item.type === 'collection') {
                 return `<a tabindex="0" href="${item.link}" class="algolia-modal-pill">${item.label}</a>`;
             } else if (item.type === 'gift-card') {
                 return `<a tabindex="0" href="/products/gift-card" class="algolia-modal-pill">${item.label}</a>`;
             } else if (item.type === 'search') {
                 return `<a tabindex="0" href="${getSlug(item.label,'search')}" class="algolia-modal-pill">${item.label}</a>`;
             }
             return '';
         });
         quicklinksContainer.innerHTML = pillHtmlArr.join('');
         quicklinksContainer.scrollLeft = 0;
         if(uniqueResults.length > 0) {
            document.getElementById('algolia-modal-heading')?.classList.remove('hide')
            document.getElementById('algolia-modal-viewall-top')?.classList.remove('hide');
         }

         // Hide scroll buttons if no quicklinks
         setScrollButtonsVisibility(pillHtmlArr.length > 0);
    }   

    if (dialog) {
        // Delegate click for product tiles and quick links inside the modal
        dialog.addEventListener('click', function(e) {
            // Adjust selectors as needed for your product tiles and quick links
            const link = e.target.closest('.ais-hit, a.algolia-modal-pill, img.ais-hit--picture,p.ais-hit--title, p.ais-hit--price');
            if (link) {
                setTimeout(() => {
                    closeBtn?.click();
                }, 20);
            }
        });  
    }


    
    

});
